import React, { Component } from "react";
import {
  Alert,
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Grid as Container,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import ViewportAlert from "components/ViewportAlert/ViewportAlert";

const API_BASE = "https://hgsystem.pl/mangusta";

const emptyUserForm = () => ({
  name: "",
  surname: "",
  email: "",
  login: "",
  password: "",
  city: "",
  status: "user",
  sendInvitation: true
});

const emptyDeviceForm = () => ({
  id: "",
  desc: "",
  type: "1",
  status: "1",
  hw_version: "",
  sw_version: "",
  user_ids: [],
  primary_user_id: ""
});

class Admin extends Component {
  state = {
    users: [],
    devices: [],
    loading: false,
    error: "",
    success: "",
    userForm: emptyUserForm(),
    deviceForm: emptyDeviceForm(),
    editUserForm: null,
    editDeviceForm: null,
    sendingInvitationUserId: null,
    sendingReminderUserId: null,
    userSortKey: "name",
    userSortDirection: "asc"
  };

  componentDidMount() {
    this.loadData();
  }

  post = (endpoint, body) =>
    fetch(`${API_BASE}/${endpoint}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        auth: this.props.adminCredentials,
        ...body
      })
    }).then(async response => {
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.error || "Wystąpił błąd serwera");
      return data;
    });

  loadData = () => {
    if (!this.props.adminCredentials) {
      this.setState({ error: "Brak uprawnień administratora" });
      return;
    }

    this.setState({ loading: true, error: "" });
    this.post("admin_data.php", {})
      .then(data => {
        const users = Array.isArray(data.users) ? data.users : [];
        const devices = Array.isArray(data.devices) ? data.devices : [];
        this.setState(previousState => {
          const firstUserId = users[0] ? String(users[0].id) : "";
          const hasSelectedUsers =
            previousState.deviceForm.user_ids.length > 0;
          return {
            users,
            devices,
            loading: false,
            deviceForm: hasSelectedUsers
              ? previousState.deviceForm
              : {
                  ...previousState.deviceForm,
                  user_ids: firstUserId ? [firstUserId] : [],
                  primary_user_id: firstUserId
                }
          };
        });
      })
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  changeForm = (formName, event) => {
    const { name, value } = event.target;
    this.setState(previousState => ({
      [formName]: { ...previousState[formName], [name]: value }
    }));
  };

  toggleUserInvitation = event => {
    const checked = event.target.checked;
    this.setState(previousState => ({
      userForm: {
        ...previousState.userForm,
        sendInvitation: checked,
        password: checked ? "" : previousState.userForm.password
      }
    }));
  };

  toggleDeviceUser = (formName, userId) => {
    const selectedId = String(userId);
    this.setState(previousState => {
      const form = previousState[formName];
      const userIds = form.user_ids.slice();
      const index = userIds.indexOf(selectedId);
      if (index >= 0)
        userIds.splice(index, 1);
      else
        userIds.push(selectedId);

      const primaryUserId =
        userIds.indexOf(form.primary_user_id) >= 0
          ? form.primary_user_id
          : userIds[0] || "";
      return {
        [formName]: {
          ...form,
          user_ids: userIds,
          primary_user_id: primaryUserId
        }
      };
    });
  };

  createUser = event => {
    event.preventDefault();
    this.setState({ loading: true, error: "", success: "" });
    this.post("create_user.php", {
      user: this.state.userForm,
      send_invitation: this.state.userForm.sendInvitation
    })
      .then(data => {
        this.setState({
          loading: false,
          success:
            data.message ||
            (data.invitation_sent === false
              ? "Użytkownik został utworzony, ale zaproszenie nie zostało wysłane."
              : "Użytkownik został utworzony"),
          userForm: emptyUserForm()
        });
        this.loadData();
      })
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  sendInvitation = user => {
    if (
      user.invitation_status === "pending" &&
      !window.confirm(
        "Poprzedni link zostanie unieważniony. Wysłać nowe zaproszenie?"
      )
    )
      return;

    this.setState({
      sendingInvitationUserId: String(user.id),
      error: "",
      success: ""
    });
    this.post("send_user_invitation.php", { user_id: Number(user.id) })
      .then(data => {
        this.setState({
          sendingInvitationUserId: null,
          success: data.message || "Zaproszenie zostało wysłane."
        });
        this.loadData();
      })
      .catch(error =>
        this.setState({
          sendingInvitationUserId: null,
          error: error.message
        })
      );
  };

  sendPortalReminder = user => {
    if (
      !window.confirm(
        `Wysłać przypomnienie o portalu na adres ${user.email}?`
      )
    )
      return;

    this.setState({
      sendingReminderUserId: String(user.id),
      error: "",
      success: ""
    });
    this.post("send_user_portal_reminder.php", {
      user_id: Number(user.id)
    })
      .then(data =>
        this.setState({
          sendingReminderUserId: null,
          success:
            data.message ||
            "Przypomnienie o dostępie do portalu zostało wysłane."
        })
      )
      .catch(error =>
        this.setState({
          sendingReminderUserId: null,
          error: error.message
        })
      );
  };

  createDevice = event => {
    event.preventDefault();
    if (this.state.deviceForm.user_ids.length === 0) {
      this.setState({ error: "Wybierz co najmniej jednego użytkownika" });
      return;
    }

    this.setState({ loading: true, error: "", success: "" });
    this.post("create_device.php", {
      device: this.devicePayload(this.state.deviceForm)
    })
      .then(() => {
        const firstUserId = this.state.users[0]
          ? String(this.state.users[0].id)
          : "";
        this.setState({
          success: "Urządzenie zostało dodane",
          deviceForm: {
            ...emptyDeviceForm(),
            user_ids: firstUserId ? [firstUserId] : [],
            primary_user_id: firstUserId
          }
        });
        this.loadData();
      })
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  devicePayload = form => ({
    ...form,
    user_ids: form.user_ids.map(Number),
    primary_user_id: Number(form.primary_user_id)
  });

  openUserEditor = user => {
    this.setState({
      error: "",
      success: "",
      editUserForm: {
        ...user,
        id: String(user.id),
        password: "",
        status: user.status || "user"
      }
    });
  };

  updateUser = event => {
    event.preventDefault();
    this.setState({ loading: true, error: "", success: "" });
    this.post("admin_update_user.php", { user: this.state.editUserForm })
      .then(data => {
        if (data.requiresLogin) {
          window.alert(
            "Dane logowania administratora zostały zmienione. Zaloguj się ponownie."
          );
          this.props.onLogout();
          return;
        }
        this.setState({
          loading: false,
          editUserForm: null,
          success: "Dane użytkownika zostały zapisane"
        });
        this.loadData();
      })
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  openDeviceEditor = device => {
    const availableUserIds = this.state.users.map(user => String(user.id));
    const assignedUserIds =
      Array.isArray(device.user_ids) && device.user_ids.length > 0
        ? device.user_ids.map(String)
        : [String(device.user_id)];
    const userIds = assignedUserIds.filter(
      userId => availableUserIds.indexOf(userId) >= 0
    );
    const legacyOwnerId = String(device.user_id);
    const primaryUserId =
      userIds.indexOf(legacyOwnerId) >= 0
        ? legacyOwnerId
        : userIds[0] || "";
    this.setState({
      error: "",
      success: "",
      editDeviceForm: {
        id: String(device.id),
        desc: device.desc || "",
        type: String(device.type == null ? 1 : device.type),
        status: String(device.status == null ? 1 : device.status),
        hw_version: device.hw_version || "",
        sw_version: device.sw_version || "",
        user_ids: userIds,
        primary_user_id: primaryUserId,
        orphaned_owner_id:
          legacyOwnerId && availableUserIds.indexOf(legacyOwnerId) < 0
            ? legacyOwnerId
            : ""
      }
    });
  };

  updateDevice = event => {
    event.preventDefault();
    if (this.state.editDeviceForm.user_ids.length === 0) {
      this.setState({ error: "Wybierz co najmniej jednego użytkownika" });
      return;
    }

    this.setState({ loading: true, error: "", success: "" });
    this.post("admin_update_device.php", {
      device: this.devicePayload(this.state.editDeviceForm)
    })
      .then(() => {
        this.setState({
          loading: false,
          editDeviceForm: null,
          success: "Dane urządzenia zostały zapisane"
        });
        this.loadData();
      })
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  formatAccountDate = value => {
    if (!value) return "—";
    const numericValue = Number(value);
    const date =
      isFinite(numericValue) && numericValue > 0
        ? new Date(numericValue * 1000)
        : new Date(`${String(value).replace(" ", "T")}Z`);
    return isNaN(date.getTime()) ? "—" : date.toLocaleString("pl-PL");
  };

  userRole = status =>
    String(status).toLowerCase() === "admin"
      ? "Administrator"
      : "Użytkownik";

  invitationStatus = user => {
    const statuses = {
      active: { text: "Aktywne", className: "label label-success" },
      pending: { text: "Oczekuje", className: "label label-warning" },
      expired: { text: "Wygasło", className: "label label-default" },
      failed: { text: "Błąd wysyłki", className: "label label-danger" },
      not_sent: { text: "Niewysłane", className: "label label-default" }
    };
    return statuses[user.invitation_status] || statuses.not_sent;
  };

  formatInvitationDate = timestamp => {
    const value = Number(timestamp);
    if (!value) return "—";
    return new Date(value * 1000).toLocaleString("pl-PL");
  };

  userSortValue = (user, key) => {
    switch (key) {
      case "name":
        return `${user.surname || ""} ${user.name || ""}`.trim();
      case "role":
        return this.userRole(user.status);
      case "account":
        return this.invitationStatus(user).text;
      case "last_login_at":
      case "invitation_sent_at": {
        return Number(user[key]) || 0;
      }
      case "created": {
        const numeric = Number(user.created);
        if (isFinite(numeric) && numeric > 0) return numeric;
        const timestamp = Date.parse(
          `${String(user.created || "").replace(" ", "T")}Z`
        );
        return isNaN(timestamp) ? 0 : timestamp;
      }
      default:
        return String(user[key] || "");
    }
  };

  sortedUsers = () => {
    const { userSortKey, userSortDirection } = this.state;
    const direction = userSortDirection === "desc" ? -1 : 1;
    return this.state.users.slice().sort((left, right) => {
      const leftValue = this.userSortValue(left, userSortKey);
      const rightValue = this.userSortValue(right, userSortKey);
      let comparison;
      if (typeof leftValue === "number" && typeof rightValue === "number")
        comparison = leftValue - rightValue;
      else
        comparison = String(leftValue).localeCompare(String(rightValue), "pl", {
          sensitivity: "base",
          numeric: true
        });
      if (comparison === 0) comparison = Number(left.id) - Number(right.id);
      return comparison * direction;
    });
  };

  changeUserSort = key => {
    this.setState(previousState => ({
      userSortKey: key,
      userSortDirection:
        previousState.userSortKey === key &&
        previousState.userSortDirection === "asc"
          ? "desc"
          : "asc"
    }));
  };

  sortableUserHeader = (label, key) => {
    const active = this.state.userSortKey === key;
    const arrow = active
      ? this.state.userSortDirection === "asc"
        ? " ▲"
        : " ▼"
      : "";
    return (
      <th>
        <button
          type="button"
          onClick={() => this.changeUserSort(key)}
          style={{
            border: 0,
            padding: 0,
            background: "transparent",
            font: "inherit",
            fontWeight: "bold",
            cursor: "pointer",
            whiteSpace: "nowrap"
          }}
          title={`Sortuj według: ${label}`}
        >
          {label}
          {arrow}
        </button>
      </th>
    );
  };

  deviceUsers = device => {
    if (Array.isArray(device.users) && device.users.length > 0)
      return device.users
        .map(user => `${user.name} ${user.surname} (${user.login})`)
        .join(", ");
    return `${device.owner_name || ""} ${device.owner_surname || ""}`.trim() || "—";
  };

  devicesForUser = user =>
    this.state.devices.filter(device => {
      const assignedIds = Array.isArray(device.user_ids)
        ? device.user_ids.map(Number)
        : [];
      return (
        assignedIds.indexOf(Number(user.id)) >= 0 ||
        Number(device.user_id) === Number(user.id)
      );
    });

  userDevicesPopover = user => {
    const devices = this.devicesForUser(user);
    return (
      <Popover
        id={`user-devices-${user.id}`}
        title={`Urządzenia: ${user.name} ${user.surname}`}
        style={{ maxWidth: 430 }}
      >
        {devices.length === 0 ? (
          <span className="text-muted">Brak przypisanych urządzeń.</span>
        ) : (
          devices.map(device => (
            <div
              key={device.number || device.id}
              style={{
                padding: "6px 0",
                borderBottom: "1px solid #eeeeee"
              }}
            >
              <strong>{device.desc || device.id}</strong>
              <br />
              <small>
                ID: {device.id}
                <br />
                Ostatni przesył:{" "}
                {this.formatInvitationDate(device.last_seen)}
              </small>
            </div>
          ))
        )}
      </Popover>
    );
  };

  renderUserFields(formName, passwordOptional) {
    const form = this.state[formName];
    const invitationCreation =
      formName === "userForm" && Boolean(form.sendInvitation);
    const fixedAdministrator =
      formName === "editUserForm" &&
      (Number(form.id) === 1 || Number(form.id) === 2);
    return (
      <React.Fragment>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Imię</ControlLabel>
              <FormControl
                name="name"
                value={form.name || ""}
                onChange={event => this.changeForm(formName, event)}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Nazwisko</ControlLabel>
              <FormControl
                name="surname"
                value={form.surname || ""}
                onChange={event => this.changeForm(formName, event)}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Login</ControlLabel>
              <FormControl
                name="login"
                value={form.login || ""}
                onChange={event => this.changeForm(formName, event)}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              {invitationCreation ? (
                <React.Fragment>
                  <ControlLabel>Hasło</ControlLabel>
                  <p className="form-control-static">
                    Użytkownik ustawi własne hasło z bezpiecznego linku.
                  </p>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <ControlLabel>
                    Hasło{passwordOptional ? " (pozostaw puste bez zmiany)" : ""}
                  </ControlLabel>
                  <FormControl
                    type="password"
                    name="password"
                    value={form.password || ""}
                    onChange={event => this.changeForm(formName, event)}
                    required={!passwordOptional}
                  />
                </React.Fragment>
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <FormGroup>
              <ControlLabel>E-mail</ControlLabel>
              <FormControl
                type="email"
                name="email"
                value={form.email || ""}
                onChange={event => this.changeForm(formName, event)}
                required={invitationCreation}
              />
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup>
              <ControlLabel>Miasto</ControlLabel>
              <FormControl
                name="city"
                value={form.city || ""}
                onChange={event => this.changeForm(formName, event)}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>Rola</ControlLabel>
              <FormControl
                componentClass="select"
                name="status"
                value={form.status || "user"}
                disabled={fixedAdministrator}
                onChange={event => this.changeForm(formName, event)}
              >
                <option value="user">Użytkownik</option>
                <option value="admin">Administrator</option>
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        {formName === "userForm" && (
          <div className="checkbox">
            <input
              id="create-user-send-invitation"
              type="checkbox"
              checked={Boolean(form.sendInvitation)}
              onChange={this.toggleUserInvitation}
            />
            <label htmlFor="create-user-send-invitation">
              Utwórz konto nieaktywne i wyślij zaproszenie e-mail
            </label>
          </div>
        )}
      </React.Fragment>
    );
  }

  renderDeviceFields(formName, idDisabled) {
    const form = this.state[formName];
    const selectedUsers = this.state.users.filter(
      user => form.user_ids.indexOf(String(user.id)) >= 0
    );
    return (
      <React.Fragment>
        <Row>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>Identyfikator urządzenia</ControlLabel>
              <FormControl
                name="id"
                value={form.id}
                disabled={idDisabled}
                onChange={event => this.changeForm(formName, event)}
                required
              />
            </FormGroup>
          </Col>
          <Col md={8}>
            <FormGroup>
              <ControlLabel>Opis</ControlLabel>
              <FormControl
                name="desc"
                value={form.desc}
                onChange={event => this.changeForm(formName, event)}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>Wersja HW</ControlLabel>
              <FormControl
                name="hw_version"
                value={form.hw_version}
                onChange={event => this.changeForm(formName, event)}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>Wersja SW</ControlLabel>
              <FormControl
                name="sw_version"
                value={form.sw_version}
                onChange={event => this.changeForm(formName, event)}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>Typ</ControlLabel>
              <FormControl
                type="number"
                name="type"
                value={form.type}
                onChange={event => this.changeForm(formName, event)}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>Status urządzenia</ControlLabel>
              <FormControl
                componentClass="select"
                name="status"
                value={form.status}
                onChange={event => this.changeForm(formName, event)}
              >
                <option value="1">Aktywne</option>
                <option value="0">Nieaktywne</option>
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <ControlLabel>Użytkownicy z dostępem</ControlLabel>
            {form.orphaned_owner_id && (
              <Alert bsStyle="warning">
                Dotychczasowy użytkownik {form.orphaned_owner_id} nie istnieje.
                Wybierz co najmniej jedno aktualne konto.
              </Alert>
            )}
            <div
              style={{
                border: "1px solid #e3e3e3",
                borderRadius: 4,
                maxHeight: 180,
                overflowY: "auto",
                padding: "6px 12px",
                marginBottom: 15
              }}
            >
              {this.state.users.map(user => {
                const checkboxId = `${formName}-user-${user.id}`;
                return (
                  <div className="checkbox" key={user.id}>
                    <input
                      id={checkboxId}
                      type="checkbox"
                      checked={form.user_ids.indexOf(String(user.id)) >= 0}
                      onChange={() => this.toggleDeviceUser(formName, user.id)}
                    />
                    <label htmlFor={checkboxId}>
                      {user.name} {user.surname} ({user.login})
                    </label>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>Główny użytkownik</ControlLabel>
              <FormControl
                componentClass="select"
                name="primary_user_id"
                value={form.primary_user_id}
                onChange={event => this.changeForm(formName, event)}
                required
              >
                {selectedUsers.map(user => (
                  <option value={user.id} key={user.id}>
                    {user.name} {user.surname}
                  </option>
                ))}
              </FormControl>
              <span className="help-block">
                Zachowywany także w starym polu właściciela.
              </span>
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="content">
        <Container fluid>
          {this.state.error && (
            <ViewportAlert
              bsStyle="danger"
              onDismiss={() => this.setState({ error: "" })}
            >
              {this.state.error}
            </ViewportAlert>
          )}
          {this.state.success && (
            <ViewportAlert
              bsStyle="success"
              onDismiss={() => this.setState({ success: "" })}
            >
              {this.state.success}
            </ViewportAlert>
          )}
          <Row>
            <Col md={12}>
              <Card
                title="Użytkownicy"
                category={`${this.state.users.length} kont`}
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        {this.sortableUserHeader("ID", "id")}
                        {this.sortableUserHeader("Imię i nazwisko", "name")}
                        {this.sortableUserHeader("Login", "login")}
                        {this.sortableUserHeader("E-mail", "email")}
                        {this.sortableUserHeader("Rola", "role")}
                        {this.sortableUserHeader("Stan konta", "account")}
                        {this.sortableUserHeader(
                          "Ostatnie logowanie",
                          "last_login_at"
                        )}
                        {this.sortableUserHeader(
                          "Ostatnie zaproszenie",
                          "invitation_sent_at"
                        )}
                        {this.sortableUserHeader("Data utworzenia", "created")}
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.sortedUsers().map(user => {
                        const invitation = this.invitationStatus(user);
                        const accountActive =
                          user.invitation_status === "active";
                        const sending =
                          this.state.sendingInvitationUserId ===
                          String(user.id);
                        const sendingReminder =
                          this.state.sendingReminderUserId ===
                          String(user.id);
                        return (
                          <OverlayTrigger
                            key={user.id}
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={this.userDevicesPopover(user)}
                            delayShow={250}
                            delayHide={100}
                          >
                          <tr tabIndex="0">
                            <td>{user.id}</td>
                            <td>{user.name} {user.surname}</td>
                            <td>{user.login}</td>
                            <td>{user.email || "—"}</td>
                            <td>{this.userRole(user.status)}</td>
                            <td>
                              <span className={invitation.className}>
                                {invitation.text}
                              </span>
                            </td>
                            <td>
                              {this.formatInvitationDate(user.last_login_at)}
                            </td>
                            <td>
                              {this.formatInvitationDate(
                                user.invitation_sent_at
                              )}
                            </td>
                            <td>{this.formatAccountDate(user.created)}</td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {!accountActive && (
                                <Button
                                  bsSize="small"
                                  bsStyle="primary"
                                  disabled={!user.email || sending}
                                  onClick={() => this.sendInvitation(user)}
                                  style={{ marginRight: 5 }}
                                >
                                  {sending
                                    ? "Wysyłanie…"
                                    : user.invitation_status === "not_sent"
                                      ? "Wyślij zaproszenie"
                                      : "Wyślij ponownie"}
                                </Button>
                              )}
                              {accountActive && (
                                <Button
                                  bsSize="small"
                                  bsStyle="info"
                                  disabled={!user.email || sendingReminder}
                                  onClick={() => this.sendPortalReminder(user)}
                                  style={{ marginRight: 5 }}
                                >
                                  {sendingReminder
                                    ? "Wysyłanie…"
                                    : "Wyślij przypomnienie"}
                                </Button>
                              )}
                              <Button
                                bsSize="small"
                                onClick={() => this.openUserEditor(user)}
                              >
                                Edytuj
                              </Button>
                            </td>
                          </tr>
                          </OverlayTrigger>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </Col>
            <Col md={12}>
              <Card
                title="Nowy użytkownik"
                category="Utwórz konto klienta"
                content={
                  <Form onSubmit={this.createUser}>
                    {this.renderUserFields("userForm", false)}
                    <Button
                      type="submit"
                      bsStyle="primary"
                      disabled={this.state.loading}
                    >
                      {this.state.userForm.sendInvitation
                        ? "Dodaj i wyślij zaproszenie"
                        : "Dodaj użytkownika"}
                    </Button>
                  </Form>
                }
              />
            </Col>
            <Col md={12}>
              <Card
                title="Nowe urządzenie"
                category="Jedno urządzenie może być dostępne dla wielu kont"
                content={
                  <Form onSubmit={this.createDevice}>
                    {this.renderDeviceFields("deviceForm", false)}
                    <Button
                      type="submit"
                      bsStyle="primary"
                      disabled={this.state.loading}
                    >
                      Dodaj urządzenie
                    </Button>
                  </Form>
                }
              />
            </Col>
            <Col md={12}>
              <Card
                title="Urządzenia"
                category={`${this.state.devices.length} urządzeń`}
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Opis</th>
                        <th>Użytkownicy z dostępem</th>
                        <th>HW</th>
                        <th>SW</th>
                        <th>Status</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.devices.map(device => (
                        <tr key={device.number || device.id}>
                          <td>{device.id}</td>
                          <td>{device.desc}</td>
                          <td>{this.deviceUsers(device)}</td>
                          <td>{device.hw_version || "—"}</td>
                          <td>{device.sw_version || "—"}</td>
                          <td>{Number(device.status) === 1 ? "Aktywne" : "Nieaktywne"}</td>
                          <td>
                            <Button
                              bsSize="small"
                              onClick={() => this.openDeviceEditor(device)}
                            >
                              Edytuj
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Container>

        <Modal
          show={this.state.editUserForm !== null}
          onHide={() => this.setState({ editUserForm: null })}
        >
          <Form onSubmit={this.updateUser}>
            <Modal.Header closeButton>
              <Modal.Title>Edycja użytkownika</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.editUserForm &&
                this.renderUserFields("editUserForm", true)}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ editUserForm: null })}>
                Anuluj
              </Button>
              <Button
                type="submit"
                bsStyle="primary"
                disabled={this.state.loading}
              >
                Zapisz
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={this.state.editDeviceForm !== null}
          onHide={() => this.setState({ editDeviceForm: null })}
        >
          <Form onSubmit={this.updateDevice}>
            <Modal.Header closeButton>
              <Modal.Title>Edycja urządzenia</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.editDeviceForm &&
                this.renderDeviceFields("editDeviceForm", true)}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ editDeviceForm: null })}>
                Anuluj
              </Button>
              <Button
                type="submit"
                bsStyle="primary"
                disabled={this.state.loading}
              >
                Zapisz
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/views/Admin.jsx